import React from 'react';

// NextFlip Logo Component - House with checkmark
export const NextFlipLogo = ({ className = "", size = "default", showText = true }) => {
  const sizes = {
    small: { icon: 32, text: "text-lg" },
    default: { icon: 40, text: "text-xl" },
    large: { icon: 56, text: "text-2xl" },
    hero: { icon: 80, text: "text-4xl" }
  };

  const currentSize = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg 
        width={currentSize.icon} 
        height={currentSize.icon} 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* House outline */}
        <path 
          d="M50 8L10 40V90H38V65H62V90H90V40L50 8Z" 
          stroke="#5DADE2" 
          strokeWidth="5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          fill="none"
        />
        {/* Chimney */}
        <path 
          d="M70 18V28L78 34V18H70Z" 
          stroke="#64748b" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          fill="none"
        />
        {/* Checkmark with gradient */}
        <defs>
          <linearGradient id="checkGradient" x1="25" y1="60" x2="75" y2="35" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#64748b" />
            <stop offset="100%" stopColor="#94a3b8" />
          </linearGradient>
        </defs>
        <path 
          d="M28 52L42 68L72 32" 
          stroke="url(#checkGradient)" 
          strokeWidth="8" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      {showText && (
        <span className={`font-heading font-bold ${currentSize.text}`}>
          <span className="text-[#5DADE2]">Next</span>
          <span className="text-slate-700">Flip</span>
        </span>
      )}
    </div>
  );
};

// Icon only version for favicons, mobile headers, etc.
export const NextFlipIcon = ({ size = 40, className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* House outline */}
    <path 
      d="M50 8L10 40V90H38V65H62V90H90V40L50 8Z" 
      stroke="#5DADE2" 
      strokeWidth="5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    {/* Chimney */}
    <path 
      d="M70 18V28L78 34V18H70Z" 
      stroke="#64748b" 
      strokeWidth="4" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    {/* Checkmark with gradient */}
    <defs>
      <linearGradient id="checkGradientIcon" x1="25" y1="60" x2="75" y2="35" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#64748b" />
        <stop offset="100%" stopColor="#94a3b8" />
      </linearGradient>
    </defs>
    <path 
      d="M28 52L42 68L72 32" 
      stroke="url(#checkGradientIcon)" 
      strokeWidth="8" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// Compact logo for small spaces (navbar mobile, etc)
export const NextFlipLogoCompact = ({ className = "" }) => (
  <div className={`flex items-center gap-1.5 ${className}`}>
    <NextFlipIcon size={32} />
    <span className="font-heading font-bold text-lg">
      <span className="text-[#5DADE2]">N</span>
      <span className="text-slate-700">F</span>
    </span>
  </div>
);

export default NextFlipLogo;
